module.exports = __webpack_public_path__ + "static/assets/821740e5a74209a737ffbebc5918a5ca.svg";